var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "38px",
    viewBox: "0 0 32 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u538B\u7F29\u5305") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "1.29822871e-16 0 31.9852264 0 31.9852264 27.4162424 1.29822871e-16 27.4162424"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u538B\\u7F29\\u5305",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "server-yasuowenjian",
    transform: "translate(-0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28266667,0 L29.6989091,0 C30.9629376,0 31.9852264,1.02228877 31.9852264,2.28608913 L31.9852264,9.14013547 L-0.00342245989,9.14013547 L-0.00342245989,2.28608913 C-0.00342245989,1.02228877 1.02331551,0 2.28266667,0 Z",
    id: "Fill-1",
    fill: "#00B9D9",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FF6264",
    mask: "url(#mask-2)",
    points: "0 18.2804991 31.980549 18.2804991 31.980549 9.14013547 0 9.14013547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.00342245989,18.2758217 L31.980549,18.2758217 L31.980549,25.1299251 C31.980549,26.3939537 30.9584884,27.4162424 29.6944599,27.4162424 L2.28266667,27.4162424 C1.01886631,27.4162424 -0.00342245989,26.3939537 -0.00342245989,25.1299251 L-0.00342245989,18.2758217 Z",
    id: "Fill-4",
    fill: "#38B17F",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FF9A1F",
    points: "11.4230303 27.4162424 20.5631658 27.4162424 20.5631658 0 11.4230303 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4178966,17.8194938 L12.5638503,17.8194938 C11.5554225,17.8194938 10.7385383,17.0026667 10.7385383,15.9941818 L10.7385383,11.4217754 C10.7385383,10.4133476 11.5554225,9.59646346 12.5638503,9.59646346 L19.4178966,9.59646346 C20.4263815,9.59646346 21.2432086,10.4133476 21.2432086,11.4217754 L21.2432086,15.9897326 C21.2432086,17.0026667 20.4263815,17.8194938 19.4178966,17.8194938 Z M12.5638503,10.9654474 C12.312984,10.9654474 12.1075223,11.1709091 12.1075223,11.4217754 L12.1075223,15.9897326 C12.1075223,16.240656 12.312984,16.4460606 12.5638503,16.4460606 L19.4178966,16.4460606 C19.66882,16.4460606 19.8742246,16.240656 19.8742246,15.9897326 L19.8742246,11.4217754 C19.8742246,11.1709091 19.66882,10.9654474 19.4178966,10.9654474 L12.5638503,10.9654474 Z",
    id: "Fill-7",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.2442f8e6996fce40710212cbbb1bca61.svg";
export { ForwardRef as ReactComponent };